import React from 'react';
import { ReviewCard } from './ReviewCard';
const reviews = [{
  name: 'Sarah M.',
  initial: 'SM',
  rating: 5,
  text: `I was the biggest skeptic. Bought it to prove my friend wrong. Three weeks later I m wearing it every day and actually using it before meetings : .The resistance thing is real it genuinely paces your breath without you having to think about it : ., ':`
}, {
  name: 'Dr. Lisa Chen',
  initial: 'LC',
  role: 'Licensed Therapist',
  rating: 5,
  text: `I recommend this to clients who struggle with traditional breathwork. The calibrated resistance removes the guesswork — they just exhale and the device does the rest. It s particularly helpful for: people who get frustrated() { }, trying to "do it right.": ,`
}, {
  name: 'Marcus R.',
  initial: 'MR',
  rating: 5,
  text: `Bought the cheap Amazon one first. Returned it same day — literally no difference from breathing normally. Tried Chime and immediately felt the resistance. It s subtle but it works : .Worth the extra $31 : ., ':`
}, {
  name: 'Jennifer K.',
  initial: 'JK',
  rating: 4,
  text: `Not a magic cure, but it does take the edge off faster than any app I ve tried : .I keep it on and use it the car before presentations whenever I feel that tight - chest, feeling, starting.Solid, tool., ',`
}, {
  name: 'David P.',
  initial: 'DP',
  rating: 5,
  text: `Former meditation app subscriber here. Cancelled everything. This is the only thing I actually use consistently because it s always there and takes zero setup. Just breathe out slowly and feel calmer. That's it.`
}, {
  name: 'Amanda T.',
  initial: 'AT',
  rating: 5,
  text: `The 30-day guarantee made it a no-brainer to try. Honestly thought I d return it. Didn't. It's been 4 months and I wear it daily. My therapist noticed I m using my rescue inhaler less often.`
}];
export function ReviewsSection() {
  return <section className="my-16" data-id="element-124">
      <h2 className="text-3xl font-bold text-center mb-4 text-gray-900" style={{
      fontFamily: 'Playfair Display, serif'
    }} data-id="element-125">
        What People Are Saying
      </h2>
      <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto" data-id="element-126">
        Real reviews from verified buyers — including skeptics who changed their
        minds
      </p>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-127">
        {reviews.map((review, index) => <ReviewCard key={index} {...review} index={index} data-id="element-128" />)}
      </div>
    </section>;
}